import { EntityType } from "../entities/entity.model";
import { FileUploadStatus } from "./dtos/file-upload-status.dto";

export interface InterfaceState {
  activeNewModal: EntityType | null;
  contextMenuOpen: boolean;
  fileUploadStatuss: { [fileId: string]: FileUploadStatus };
}

export const initialState: InterfaceState = {
  activeNewModal: null,
  contextMenuOpen: false,
  fileUploadStatuss: {},
};
